"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionParser = void 0;
const AbstractParseTreeVisitor_1 = require("antlr4ts/tree/AbstractParseTreeVisitor");
const errors_1 = require("./errors");
const expressionParser_1 = require("./expressionParser");
const statementParser_1 = require("./statementParser");
const typeParser_1 = require("./typeParser");
const util_1 = require("./util");
class FunctionParser extends AbstractParseTreeVisitor_1.AbstractParseTreeVisitor {
    defaultResult() {
        return { type: 'EmptyStatement' };
    }
    bodyWrapper(ctx) {
        const body = ctx._body;
        if (body == undefined) {
            return [this.defaultResult()];
        }
        const statements = new statementParser_1.StatementParser().visit(body);
        if (statements.type == 'BlockStatement') {
            return statements.body;
        }
        else {
            return [statements];
        }
    }
    paramsWrapper(ctx) {
        if (ctx._params == undefined) {
            return [];
        }
        const params = ctx._params;
        const expressionParser = new expressionParser_1.default();
        const patterns = [];
        for (let i = 0; i < params.childCount; i++) {
            const child = params.getChild(i);
            // brute force comma work around
            if (child.text != ',') {
                patterns.push(expressionParser.visit(child));
            }
        }
        return patterns;
    }
    visitErrorNode(node) {
        throw new errors_1.FatalSyntaxError({
            start: {
                line: node.symbol.line,
                column: node.symbol.charPositionInLine
            },
            end: {
                line: node.symbol.line,
                column: node.symbol.charPositionInLine + 1
            }
        }, `invalid syntax ${node.text}`);
    }
    visitFunctionDeclaration(ctx) {
        return this.visitFunctionProperties(ctx.function());
    }
    visitFunctionProperties(ctx) {
        const id = (0, util_1.tokenToIdentifierWrapper)(ctx._id);
        const type = new typeParser_1.TypeParser().visit(ctx._idType);
        return {
            type: 'FunctionDeclaration',
            id: id,
            body: { type: 'BlockStatement', body: this.bodyWrapper(ctx) },
            params: this.paramsWrapper(ctx),
            typeDeclaration: type
        };
    }
}
exports.FunctionParser = FunctionParser;
//# sourceMappingURL=functionParser.js.map